import { defineComponent } from "vue";
import { searchStore } from "../store/callSearch";

export default defineComponent({
    emits: ["input"],
    setup(_, { emit }) {
        function update(val: string) {
            searchStore.searchTerm = val; // write directly to store
        }

        return { searchStore, update };
    }
});
